import { parseISO } from 'date-fns'

import { DEFAULT_DATE_FORMATTING_LOCALE } from '../../app/constants'
import { TREND_DATE_FORMAT_OPTIONS } from '../../features/Processes/ProcessMining/TrendConstants'

/**
 * Formats a timestamp string to a human-readable date format.
 * Uses the same format as other parts of the application for consistency.
 */
export const formatTimestamp = (timestamp: string): string => {
  try {
    const date = parseISO(timestamp)
    return date.toLocaleString(DEFAULT_DATE_FORMATTING_LOCALE, TREND_DATE_FORMAT_OPTIONS)
  } catch (error) {
    console.error('Error parsing timestamp:', timestamp, error)
    return 'Invalid date'
  }
}

/**
 * Formats the current time to human readable format.
 */
export const getCurrentFormattedTime = (): string => {
  return new Date().toLocaleString(DEFAULT_DATE_FORMATTING_LOCALE, {
    ...TREND_DATE_FORMAT_OPTIONS,
    hour: '2-digit',
    minute: '2-digit',
  })
}

/**
 * Downloads a blob as a file with the specified filename.
 */
export const downloadBlobAsFile = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

